const products_on_page = document.getElementById('product-grid');
let next_url = products_on_page.dataset.nextUrl;

const load_more_btn = document.getElementsByClassName('load-more_btn')[0];
const load_more_spinner = document.getElementsByClassName('load-more_spinner')[0];
async function getNextPage() {
  try {
    let res = await fetch(next_url);
    return await res.text();
  } catch (error) {
    console.log(error);
  }
}

async function loadMoreProducts() {
  load_more_btn.style.display = 'none';
  load_more_spinner.style.display = 'block';
  let nextPage = await getNextPage();

  const parser = new DOMParser();
  const nextPageDoc = parser.parseFromString(nextPage, 'text/html');

  load_more_spinner.style.display = 'none';

  const productgrid = nextPageDoc.getElementById('product-grid');
  let new_products;
  if (productgrid.getElementsByClassName('grid__item').length !== 0) {
    new_products = productgrid.getElementsByClassName('grid__item');
  } else {
    new_products = productgrid.getElementsByClassName('blog-articles__article');
  }
  
  const new_url = productgrid.dataset.nextUrl;
  if (new_url) {
    load_more_btn.style.display = 'flex';
  }
  next_url = new_url;
  for (let i = 0; i < new_products.length; i++) {
    products_on_page.appendChild(new_products[i]);
  }
}


/*Loadmore Pagination*/
class PaginateLoadmore extends HTMLElement {
  constructor() {
    super();
    this.loading = false;
    this.initLoadMore();
  }
  initLoadMore() {
    this.querySelectorAll('.actions-loadmore').forEach((loadMore) => {
      var _this = this;
        loadMore.addEventListener(
          'click',
          (event) => {
            event.preventDefault();
            const target = event.currentTarget;
            _this.loadMoreItem(target);
          },
          false
        );
      // Leon 3 Sep: infinite scroll, replaces the click. The button stays in
      // the DOM as a fallback (slow connections, JS off) but under normal
      // conditions the next page loads itself once the link nears view.
      _this.observeForAutoLoad(loadMore);
    });
  }
  observeForAutoLoad(target) {
    const _this = this;
    if (this._io) {
      this._io.disconnect();
    }
    this._io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !_this.loading) {
            _this.loadMoreItem(target);
          }
        });
      },
      { rootMargin: '600px 0px 600px 0px' }
    );
    this._io.observe(target);
  }
  loadMoreItem(target) {
    const loadMore_url = target.getAttribute('href');
    const _this = this;
    if (this._io) {
      this._io.unobserve(target);
    }
    this.loading = true;
    _this.toggleLoading(target);
    fetch(`${loadMore_url}`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          throw error;
        }
        return response.text();
      })
      .then((responseText) => {
        const parser = new DOMParser();
        const resultNodes = parser.parseFromString(responseText, 'text/html');
        const resultNodesHtml = resultNodes.querySelectorAll(
          '.loadmore-lists .loadmore-item'
        );
        resultNodesHtml.forEach((prodNode) =>
          document.querySelector('.loadmore-lists').appendChild(prodNode)
        );
        const load_more = resultNodes.querySelector('.actions-loadmore');
        document.querySelector('.load-more-bar').innerHTML =
          resultNodes.querySelector('.load-more-bar').innerHTML;
        if (load_more) {
          target.setAttribute('href', load_more.getAttribute('href'));
          _this.observeForAutoLoad(target);
        } else {
          target.remove();
        }
        _this.loading = false;
        _this.toggleLoading(target);
      })
      .catch((error) => {
        _this.loading = false;
        throw error;
      });
  }
  toggleLoading(event) {
    if (event) {
      const loader = event.querySelector('.loading__spinner');
      if(loader.classList.contains('hidden')){
        loader.classList.remove('hidden');
      }else{
        loader.classList.add('hidden');
      }
    }
  }
}
customElements.define('loadmore-button', PaginateLoadmore);